const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

type ConfettiBurstInput = {
	rewardValue: number;
	stakeValue?: number;
	multiplier?: number;
};

export type ConfettiBurst = {
	intensity: number;
	duration: number;
};

/**
 * Computes a confetti burst configuration based on reward value, stake size, and multiplier.
 */
export function calculateConfettiBurst({ rewardValue, stakeValue, multiplier }: ConfettiBurstInput): ConfettiBurst {
	const safeReward = Math.max(0, rewardValue);
	const safeStake = Math.max(0, stakeValue ?? 0);
	const derivedMultiplier = multiplier ?? (safeStake > 0 ? safeReward / safeStake : 0);

	const rewardScore = Math.log10(safeReward + 1); // grows slowly with absolute reward value
	const stakeScore = Math.log10(safeStake + 1); // rewards higher wagers
	const multiplierScore = Math.log2(derivedMultiplier + 1); // emphasises high multipliers

	const combinedScore = rewardScore * 0.5 + stakeScore * 0.3 + multiplierScore * 0.2;
	const intensity = clamp(0.18 + combinedScore / 5, 0.18, 0.85);
	const duration = clamp(2000 + combinedScore * 700, 2000, 4800);

	return {
		intensity,
		duration,
	};
}
